"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyEvent = exports.Event = exports.$Event = exports.applyAnswerAmendmentEvent = exports.AnswerAmendmentEvent = exports.applyAnswerEvent = exports.AnswerEvent = exports.applyQuestionEvent = exports.QuestionEvent = exports.applyStatusEvent = exports.StatusEvent = exports.applyMetadataEvent = exports.MetadataEvent = exports.TroubleshootingChat = exports.Metadata = exports.Status = exports.$Status = exports.RunningStatus = exports.FailedStatus = exports.DoneStatus = exports.Message = exports.$Message = exports.Answer = exports.Question = exports.Id = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const class_1 = require("./class");
exports.NAMESPACE = 'Culligan.Device.TroubleshootingChat';
exports.Id = effect_1.Schema.UUID.annotations({
    identifier: `${exports.NAMESPACE}.Id`,
    title: 'Troubleshooting Chat ID',
});
exports.Question = effect_1.Schema.TaggedStruct('Question', {
    question: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.Question`,
    title: 'Troubleshooting Chat Question',
});
exports.Answer = effect_1.Schema.TaggedStruct('Answer', {
    answer: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.Answer`,
    title: 'Troubleshooting Chat Answer',
});
exports.$Message = effect_1.Data.taggedEnum();
exports.Message = effect_1.Schema.Union(exports.Question, exports.Answer).annotations({
    identifier: `${exports.NAMESPACE}.Message`,
    title: 'Troubleshooting Chat Message',
});
exports.DoneStatus = effect_1.Schema.TaggedStruct('Done', {}).annotations({
    identifier: `${exports.NAMESPACE}.DoneStatus`,
    title: 'Troubleshooting Chat Done Status',
});
exports.FailedStatus = effect_1.Schema.TaggedStruct('Failed', {
    message: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.FailedStatus`,
    title: 'Troubleshooting Chat Failed Status',
});
exports.RunningStatus = effect_1.Schema.TaggedStruct('Running', {
    statusText: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({
        examples: ['Getting started...', 'Thinking...'],
        description: 'The status text given by the LLM engine',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.RunningStatus`,
    title: 'Troubleshooting Chat Running Status',
});
exports.$Status = effect_1.Data.taggedEnum();
exports.Status = effect_1.Schema.Union(exports.DoneStatus, exports.FailedStatus, exports.RunningStatus).annotations({
    identifier: `${exports.NAMESPACE}.Status`,
    title: 'Troubleshooting Chat Status',
});
exports.Metadata = effect_1.Schema.Struct({
    id: exports.Id,
    title: effect_1.Schema.Option(effect_1.Schema.NonEmptyTrimmedString),
    lastUpdated: effect_1.Schema.DateTimeUtc,
    deviceId: effect_1.Schema.propertySignature(class_1.Common.Id).annotations({
        description: 'Every chat is scoped to a device. The agent can look up ' +
            'information on the corresponding device and use that in its answers',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.Metadata`,
    title: 'Troubleshooting Chat Metadata',
});
exports.TroubleshootingChat = exports.Metadata.pipe(effect_1.Schema.extend(effect_1.Schema.Struct({
    status: exports.Status,
    messages: effect_1.Schema.Array(exports.Message),
}))).annotations({
    identifier: `${exports.NAMESPACE}.TroubleshootingChat`,
    title: 'Troubleshooting Chat',
});
exports.MetadataEvent = effect_1.Schema.TaggedStruct('Metadata', exports.Metadata.fields).annotations({
    identifier: `${exports.NAMESPACE}.MetadataEvent`,
    title: 'Troubleshooting Chat Metadata Event',
});
const applyMetadataEvent = (state, { id, title, deviceId }) => ({ ...state, id, title, deviceId });
exports.applyMetadataEvent = applyMetadataEvent;
exports.StatusEvent = effect_1.Schema.TaggedStruct('Status', {
    status: exports.Status,
}).annotations({
    identifier: `${exports.NAMESPACE}.StatusEvent`,
    title: 'Troubleshooting Chat Status Event',
});
const applyStatusEvent = (state, { status }) => ({ ...state, status });
exports.applyStatusEvent = applyStatusEvent;
exports.QuestionEvent = effect_1.Schema.TaggedStruct('Question', {
    question: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.QuestionEvent`,
    title: 'Troubleshooting Chat Question Event',
});
const applyQuestionEvent = (state, { question }) => ({
    ...state,
    messages: effect_1.Array.matchRight(state.messages, {
        onEmpty: () => [exports.$Message.Question({ question })],
        onNonEmpty: (init, last) => {
            return exports.$Message.$match(last, {
                Answer: answer => effect_1.Array.appendAll(init, [answer, exports.$Message.Question({ question })]),
                Question: () => effect_1.Array.append(init, exports.$Message.Question({ question })),
            });
        },
    }),
});
exports.applyQuestionEvent = applyQuestionEvent;
exports.AnswerEvent = effect_1.Schema.TaggedStruct('Answer', {
    answer: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.AnswerEvent`,
    title: 'Troubleshooting Chat Message Amendment Event',
});
const applyAnswerEvent = (state, { answer }) => ({
    ...state,
    messages: effect_1.Array.matchRight(state.messages, {
        onEmpty: () => [exports.$Message.Answer({ answer })],
        onNonEmpty: (init, last) => {
            return exports.$Message.$match(last, {
                Question: question => effect_1.Array.appendAll(init, [question, exports.$Message.Answer({ answer })]),
                Answer: () => effect_1.Array.append(init, exports.$Message.Answer({ answer })),
            });
        },
    }),
});
exports.applyAnswerEvent = applyAnswerEvent;
exports.AnswerAmendmentEvent = effect_1.Schema.TaggedStruct('AnswerAmendment', {
    amendment: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.AnswerAmendmentEvent`,
    title: 'Troubleshooting Chat Message Amendment Event',
});
const applyAnswerAmendmentEvent = (state, { amendment }) => ({
    ...state,
    messages: effect_1.Array.matchRight(state.messages, {
        onEmpty: () => [exports.$Message.Answer({ answer: amendment })],
        onNonEmpty: (init, last) => {
            return exports.$Message.$match(last, {
                Question: question => effect_1.Array.appendAll(init, [question, exports.$Message.Answer({ answer: amendment })]),
                Answer: ({ answer }) => effect_1.Array.append(init, exports.$Message.Answer({ answer: answer + amendment })),
            });
        },
    }),
});
exports.applyAnswerAmendmentEvent = applyAnswerAmendmentEvent;
exports.$Event = effect_1.Data.taggedEnum();
exports.Event = effect_1.Schema.Union(exports.MetadataEvent, exports.QuestionEvent, exports.AnswerAmendmentEvent, exports.AnswerEvent, exports.StatusEvent).annotations({
    identifier: `${exports.NAMESPACE}.Event`,
    title: 'Troubleshooting Chat Event',
});
const applyEvent = (state, event) => {
    return exports.$Event.$match(event, {
        Metadata: metadata => (0, exports.applyMetadataEvent)(state, metadata),
        Status: status => (0, exports.applyStatusEvent)(state, status),
        Question: question => (0, exports.applyQuestionEvent)(state, question),
        Answer: answer => (0, exports.applyAnswerEvent)(state, answer),
        AnswerAmendment: answer => (0, exports.applyAnswerAmendmentEvent)(state, answer),
    });
};
exports.applyEvent = applyEvent;
//# sourceMappingURL=troubleshooting-chat.js.map